import React, { useState, useEffect, useMemo } from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import Menu from "../sections/Menu";
import Footer from "../sections/Footer";
import AnimatedCounter from "../components/AnimatedCounter";
import PageMeta from "../seo/PageMeta";
import { buildArticleStructuredData } from "../seo/structuredData";

function CaseStudyHrCentre() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetch("/data/content.json")
      .then((res) => res.json())
      .then((data) => setContent(data))
      .catch((error) => console.error("Error loading JSON:", error));
  }, []);

  const articleStructuredData = useMemo(
    () => [
      buildArticleStructuredData({
        path: "/case-study/hr-centre",
        headline: "Jak HR Centre zautomatyzowała procesy HR dzięki eGodziny",
        description:
          "Case study wdrożenia eGodziny w HR Centre i automatyzacji procesów raportowania czasu pracy.",
        authorName: "Zespół eGodziny",
      }),
    ],
    []
  );

  if (!content) return <div></div>;

  return (
    <>
      <PageMeta
        path="/case-study/hr-centre"
        structuredData={articleStructuredData}
        ogType="article"
      />
      <Menu />

      <Container
        className="py-5"
        style={{ paddingTop: "120px", minHeight: "90vh", maxWidth: "900px" }}
      >
        <Row className="justify-content-center">
          <Col lg={12} className="px-4">
            <div className="text-center mb-5">
              <h1
                className="mb-4"
                style={{ fontSize: "3rem", fontWeight: "bold" }}
              >
                Jak HR Centre zautomatyzowała procesy HR dzięki eGodziny
              </h1>
            </div>

            <div
              style={{
                backgroundColor: "#f8f9fa",
                borderRadius: "20px",
                padding: "50px",
                marginBottom: "50px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
              }}
            >
              {/* Quote first */}
              <Row className="mb-3">
                <Col md={12}>
                  <blockquote
                    style={{
                      margin: 0,
                      fontSize: "24px",
                      lineHeight: "1.6",
                      textAlign: "center",
                    }}
                  >
                    <p
                      style={{
                        fontStyle: "italic",
                        marginBottom: "30px",
                        color: "#333",
                        fontSize: "26px",
                      }}
                    >
                      "Dzięki eGodziny mogliśmy w pełni zautomatyzować proces
                      raportowania czasu pracy naszych 200+ pracowników
                      tymczasowych"
                    </p>
                  </blockquote>
                </Col>
              </Row>

              {
                /* Logo left, info right */
                <Row className="align-items-center">
                  <Col md={4}>
                    <div style={{ textAlign: "left" }}>
                      <Image
                        src={require("../images/personal-system-service.png")}
                        alt="HR Centre Logo"
                        style={{
                          width: "180px",
                          height: "auto",
                          borderRadius: "10px",
                        }}
                      />
                    </div>
                  </Col>
                  <Col md={8}>
                    <div
                      style={{
                        textAlign: "left",
                        fontSize: "16px",
                        paddingLeft: "20px",
                      }}
                    >
                      <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                        Anna Kowalska
                      </div>
                      <div style={{ color: "#666", marginBottom: "3px" }}>
                        Dyrektor HR
                      </div>
                      <div style={{ color: "#666" }}>
                        HR Centre sp. z o.o.
                      </div>
                    </div>
                  </Col>
                </Row>
              }
            </div>

            <div className="mb-5">
              <h2
                className="mb-4"
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#1f2937",
                }}
              >
                O firmie
              </h2>
              <div className="row">
                <div className="col-md-6">
                  <ul
                    style={{
                      fontSize: "18px",
                      lineHeight: "1.8",
                      listStyle: "none",
                      padding: 0,
                    }}
                  >
                    <li className="mb-3">
                      <strong>Branża:</strong> praca tymczasowa
                    </li>
                    <li className="mb-3">
                      <strong>Specjalizacja:</strong> outsourcing pracowników
                    </li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <ul
                    style={{
                      fontSize: "18px",
                      lineHeight: "1.8",
                      listStyle: "none",
                      padding: 0,
                    }}
                  >
                    <li className="mb-3">
                      <strong>Zespół:</strong> 200+ pracowników tymczasowych
                    </li>
                    <li className="mb-3">
                      <strong>Skala:</strong> 15+ firm klientów jednocześnie
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="mb-5">
              <h2
                className="mb-4"
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#1f2937",
                }}
              >
                Wyzwania przed wdrożeniem
              </h2>
              <p
                className="mb-4"
                style={{ fontSize: "18px", lineHeight: "1.8" }}
              >
                Zarządzanie czasem pracy pracowników tymczasowych było bardzo
                skomplikowane:
              </p>
              <ul style={{ fontSize: "18px", lineHeight: "1.8" }}>
                <li className="mb-3">
                  Każdy pracownik pracował u różnych klientów w różnych
                  godzinach.
                </li>
                <li className="mb-3">
                  Raportowanie odbywało się przez SMS-y i telefony - chaos
                  informacyjny.
                </li>
                <li className="mb-3">
                  Brak możliwości weryfikacji rzeczywistej obecności na
                  stanowisku pracy.
                </li>
                <li className="mb-3">
                  Przygotowanie list płac zajmowało zespołowi HR całe weekendy.
                </li>
                <li className="mb-3">
                  Częste błędy w naliczeniach powodowały reklamacje i straty.
                </li>
                <li className="mb-3">
                  Brak jasnej komunikacji między pracownikami a działem HR.
                </li>
                <li className="mb-3">
                  Trudność w monitorowaniu kosztów pracy dla poszczególnych
                  klientów.
                </li>
              </ul>
            </div>

            <div className="mb-5">
              <h2
                className="mb-4"
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#1f2937",
                }}
              >
                Decyzja o wdrożeniu
              </h2>
              <p
                className="mb-4"
                style={{ fontSize: "18px", lineHeight: "1.8" }}
              >
                Firma szukała rozwiązania, które pozwoli na pełną automatyzację
                procesu raportowania czasu pracy i zwiększy kontrolę nad
                pracownikami terenowymi.
              </p>
              <blockquote
                style={{
                  backgroundColor: "#f8f9fa",
                  borderLeft: "4px solid #407EF9",
                  padding: "20px",
                  margin: "20px 0",
                  fontStyle: "italic",
                  fontSize: "18px",
                  lineHeight: "1.6",
                }}
              >
                "Potrzebowaliśmy systemu, który pozwoli nam w czasie
                rzeczywistym śledzić gdzie pracują nasi ludzie i ile godzin
                przepracowali. eGodziny okazały się idealnym rozwiązaniem."
              </blockquote>
            </div>

            <div className="mb-5">
              <h2
                className="mb-4"
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#1f2937",
                }}
              >
                Rezultaty
              </h2>
              <ul style={{ fontSize: "18px", lineHeight: "1.8" }}>
                <li className="mb-3">
                  Pełna automatyzacja procesu raportowania czasu pracy -
                  pracownicy sami rejestrują początek i koniec pracy.
                </li>
                <li className="mb-3">
                  Weryfikacja GPS pozwala na 100% pewność, że pracownik
                  rzeczywiście jest na właściwym stanowisku.
                </li>
              </ul>

              <blockquote
                style={{
                  backgroundColor: "#f8f9fa",
                  borderLeft: "4px solid #407EF9",
                  padding: "20px",
                  margin: "30px 0",
                  fontStyle: "italic",
                  fontSize: "18px",
                  lineHeight: "1.6",
                }}
              >
                "Wcześniej spędzaliśmy całe weekendy na przygotowywaniu list
                płac. Teraz system automatycznie generuje wszystkie zestawienia
                - oszczędzamy minimum 16 godzin tygodniowo."
              </blockquote>

              <ul style={{ fontSize: "18px", lineHeight: "1.8" }}>
                <li className="mb-3">
                  Czas przygotowania listy płac skrócił się z{" "}
                  <strong>2 dni do 2 godzin</strong>.
                </li>
                <li className="mb-3">
                  Automatyczne raportowanie dla klientów - każdy otrzymuje
                  szczegółowe zestawienia bez dodatkowego nakładu pracy.
                </li>
              </ul>

              <blockquote
                style={{
                  backgroundColor: "#f8f9fa",
                  borderLeft: "4px solid #407EF9",
                  padding: "20px",
                  margin: "30px 0",
                  fontStyle: "italic",
                  fontSize: "18px",
                  lineHeight: "1.6",
                }}
              >
                "Nasi klienci są zachwyceni transparentnością. Mogą w każdej
                chwili sprawdzić ile godzin przepracowali wysłani do nich
                pracownicy i mieć pewność co do rozliczenia."
              </blockquote>

              <p
                className="mb-3"
                style={{ fontSize: "18px", lineHeight: "1.8" }}
              >
                System znacznie poprawił komunikację i zaufanie między
                wszystkimi stronami - pracownikami, HR Centre i firmami
                klientami.
              </p>
            </div>

            <div className="mb-5">
              <h2
                className="mb-5 text-center"
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#1f2937",
                }}
              >
                Korzyści
              </h2>

              <Row className="mb-4 g-4">
                <Col md={6}>
                  <div
                    className="p-4 text-center"
                    style={{
                      background:
                        "linear-gradient(135deg, #f8f9fa 100%, rgba(255, 255, 255, 0.8) 100%)",
                      borderRadius: "20px",
                      height: "100%",
                      boxShadow: "0 20px 40px rgba(102, 126, 234, 0.3)",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "-50%",
                        left: "-50%",
                        width: "200%",
                        height: "200%",
                        background:
                          "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
                      }}
                    ></div>
                    <div style={{ position: "relative", zIndex: 2 }}>
                      <h4
                        style={{
                          fontSize: "1.25rem",
                          fontWeight: "600",
                          color: "#1f2937",
                          marginBottom: "20px",
                        }}
                      >
                        Oszczędność czasu administracyjnego
                      </h4>
                      <div
                        style={{
                          fontSize: "2.5rem",
                          color: "#1f2937",
                          marginBottom: "10px",
                          lineHeight: "1.2",
                          fontWeight: "bold",
                        }}
                      >
                        <AnimatedCounter value={85} suffix="%" />
                      </div>
                      <p
                        style={{
                          fontSize: "0.9rem",
                          color: "#1f2937",
                          margin: 0,
                          lineHeight: "1.4",
                        }}
                      >
                        redukcja czasu potrzebnego na administrację
                      </p>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div
                    className="p-4 text-center"
                    style={{
                      background:
                        "linear-gradient(135deg, #f8f9fa 100%, rgba(255, 255, 255, 0.8) 100%)",
                      borderRadius: "20px",
                      height: "100%",
                      boxShadow: "0 20px 40px rgba(102, 126, 234, 0.3)",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "-50%",
                        left: "-50%",
                        width: "200%",
                        height: "200%",
                        background:
                          "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
                      }}
                    ></div>
                    <div style={{ position: "relative", zIndex: 2 }}>
                      <h4
                        style={{
                          fontSize: "1.25rem",
                          fontWeight: "600",
                          color: "#1f2937",
                          marginBottom: "20px",
                        }}
                      >
                        Przygotowanie listy płac
                      </h4>
                      <div
                        style={{
                          fontSize: "2.5rem",
                          color: "#1f2937",
                          marginBottom: "10px",
                          lineHeight: "1.2",
                          fontWeight: "bold",
                        }}
                      >
                        <AnimatedCounter value={90} suffix="%" />
                      </div>
                      <p
                        style={{
                          fontSize: "0.9rem",
                          color: "#1f2937",
                          margin: 0,
                          lineHeight: "1.4",
                        }}
                      >
                        szybciej (z 2 dni na 2 godziny)
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="mb-4 g-4">
                <Col md={6}>
                  <div
                    className="p-4 text-center"
                    style={{
                      background:
                        "linear-gradient(135deg, #f8f9fa 100%, rgba(255, 255, 255, 0.8) 100%)",
                      borderRadius: "20px",
                      height: "100%",
                      boxShadow: "0 20px 40px rgba(102, 126, 234, 0.3)",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "-50%",
                        left: "-50%",
                        width: "200%",
                        height: "200%",
                        background:
                          "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
                      }}
                    ></div>
                    <div style={{ position: "relative", zIndex: 2 }}>
                      <h4
                        style={{
                          fontSize: "1.25rem",
                          fontWeight: "600",
                          color: "#1f2937",
                          marginBottom: "20px",
                        }}
                      >
                        Weryfikacja obecności
                      </h4>
                      <div
                        style={{
                          fontSize: "2.5rem",
                          color: "#1f2937",
                          marginBottom: "10px",
                          lineHeight: "1.2",
                          fontWeight: "bold",
                        }}
                      >
                        <AnimatedCounter value={100} suffix="%" />
                      </div>
                      <p
                        style={{
                          fontSize: "0.9rem",
                          color: "#1f2937",
                          margin: 0,
                          lineHeight: "1.4",
                        }}
                      >
                        pewność lokalizacji dzięki GPS
                      </p>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div
                    className="p-4 text-center"
                    style={{
                      background:
                        "linear-gradient(135deg, #f8f9fa 100%, rgba(255, 255, 255, 0.8) 100%)",
                      borderRadius: "20px",
                      height: "100%",
                      boxShadow: "0 20px 40px rgba(102, 126, 234, 0.3)",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "-50%",
                        left: "-50%",
                        width: "200%",
                        height: "200%",
                        background:
                          "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
                      }}
                    ></div>
                    <div style={{ position: "relative", zIndex: 2 }}>
                      <h4
                        style={{
                          fontSize: "1.25rem",
                          fontWeight: "600",
                          color: "#1f2937",
                          marginBottom: "20px",
                        }}
                      >
                        Zadowolenie klientów
                      </h4>
                      <div
                        style={{
                          fontSize: "1.2rem",
                          color: "#1f2937",
                          fontWeight: "bold",
                          lineHeight: "1.4",
                        }}
                      >
                        pełna transparentność i automatyczne raportowanie
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="text-center mt-5">
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    borderRadius: "20px",
                    padding: "40px",
                    boxShadow: "0 20px 40px rgba(102, 126, 234, 0.3)",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "-50%",
                      left: "-50%",
                      width: "200%",
                      height: "200%",
                      background:
                        "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
                      animation: "pulse 3s ease-in-out infinite",
                    }}
                  ></div>
                  <div style={{ position: "relative", zIndex: 2 }}>
                    <div
                      style={{
                        fontSize: "4rem",
                        fontWeight: "bold",
                        color: "white",
                        marginBottom: "15px",
                      }}
                    >
                      <AnimatedCounter
                        value={16}
                        suffix=" h/tydzień"
                        duration={3000}
                      />
                    </div>
                    <p
                      style={{
                        fontSize: "1.3rem",
                        margin: 0,
                        fontWeight: "600",
                        color: "white",
                      }}
                    >
                      Oszczędność czasu zespołu HR
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center">
              <h3 className="mb-4">Chcesz osiągnąć podobne rezultaty?</h3>
              <Button
                className="button-default btn-lg me-3"
                onClick={() =>
                  window.open(
                    "https://calendly.com/krzysztof-warda-egodziny/30min",
                    "_blank",
                  )
                }
              >
                Umów demo
              </Button>
              <Button
                variant="outline-dark"
                className="btn-lg"
                href="/#contact"
              >
                Skontaktuj się z nami
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
}

export default CaseStudyHrCentre;
